/**
 * 日志工具模块
 * 
 * 在开发环境中，可以通过设置 DEBUG_ENABLED 来控制是否显示调试信息
 * 在生产环境中，调试信息将不会显示
 */

// 检查当前环境
const isProd = process.env.NODE_ENV === 'production';

// 在开发环境中可以通过修改此变量来控制是否显示调试信息
const DEBUG_ENABLED = false;

// 检查是否应该显示调试信息
const shouldShowDebug = !isProd && DEBUG_ENABLED;

/**
 * 日志工具对象
 */
export const logger = {
  /**
   * 输出调试信息
   * 仅在开发环境且 DEBUG_ENABLED 为 true 时显示
   */
  debug: (...args) => { if (shouldShowDebug) console.debug(...args); },
  
  /**
   * 输出普通日志
   * 仅在开发环境时显示
   */
  //log: (...args) => { if (!isProd) console.log(...args); },
  log: (...args) =>  console.log(...args),
  /**
   * 输出错误信息
   * 在所有环境中都会显示
   */
  error: (...args) => console.error(...args),
  
  /**
   * 输出警告信息
   * 在所有环境中都会显示
   */
  warn: (...args) => console.warn(...args),
  
  /**
   * 输出信息
   * 在所有环境中都会显示
   */
  info: (...args) => console.info(...args),
};

// 为了方便使用，同时导出环境标志和调试开关
export const isProduction = isProd;
export const isDebugEnabled = shouldShowDebug; 